<template>
	<div class="dropdown-sortir">
		<button class="btn btn-secondary dropdown-toggle font-weight-600" type="button"
		        :id="'dropdownMenuButton-' + jenisFilter" data-toggle="dropdown" aria-haspopup="true"
		        aria-expanded="false">Filter
		</button>
		<div class="dropdown-menu">
			<div class="dropdown-item color-0000">Urutkan:</div>
			<div class="dropdown-item color-206CF" href="#"
			     v-on:click="selectSorting('asc', jenisFilter)"
			     :class="{ 'selected-filter' : selectedSorting === 'asc' }"
			     v-if="!(jenisFilter === 'listPotongan' || jenisFilter === 'listKasbonKaryawan' || jenisFilter === 'absen')"
			>
				Abjad A - Z
				<img src="../assets/icons/checked-blue.svg" alt="" class="m-l-12" v-if="selectedSorting === 'asc'">
			</div>
			<div class="dropdown-item color-206CF" href="#"
			     v-on:click="selectSorting('desc', jenisFilter)"
			     :class="{ 'selected-filter' : selectedSorting === 'desc' }"
			     v-if="!(jenisFilter === 'listPotongan' || jenisFilter === 'listKasbon' || jenisFilter === 'absen')"
			>
				Abjad Z - A
				<img src="../assets/icons/checked-blue.svg" alt="" class="m-l-12" v-if="selectedSorting === 'desc'">
			</div>
			<div class="dropdown-item color-206CF" href="#"
			     v-on:click="selectSorting('terbaru', jenisFilter)"
			     :class="{ 'selected-filter' : selectedSorting === 'terbaru' }"
			     v-if="!(jenisFilter === 'absen')"
			>
				Terbaru
				<img src="../assets/icons/checked-blue.svg" alt="" class="m-l-12" v-if="selectedSorting === 'terbaru'">
			</div>
			<div class="dropdown-item color-206CF" href="#"
			     v-on:click="selectSorting('terlama', jenisFilter)"
			     :class="{ 'selected-filter' : selectedSorting === 'terlama' }"
			     v-if="!(jenisFilter === 'absen')"
			>
				Terlama
				<img src="../assets/icons/checked-blue.svg" alt="" class="m-l-12" v-if="selectedSorting === 'terlama'">
			</div>

			<div class="dropdown-item color-206CF" href="#"
			     v-on:click="selectSorting('terbaruAbsensi', jenisFilter)"
			     :class="{ 'selected-filter' : selectedSorting === 'terbaruAbsensi' }"
			     v-if="(jenisFilter === 'absen')"
			>
				Terbaru
				<img src="../assets/icons/checked-blue.svg" alt="" class="m-l-12" v-if="selectedSorting === 'terbaru'">
			</div>
			<div class="dropdown-item color-206CF" href="#"
			     v-on:click="selectSorting('terlamaAbsensi', jenisFilter)"
			     :class="{ 'selected-filter' : selectedSorting === 'terlamaAbsensi' }"
			     v-if="(jenisFilter === 'absen')"
			>
				Terlama
				<img src="../assets/icons/checked-blue.svg" alt="" class="m-l-12" v-if="selectedSorting === 'terlama'">
			</div>

			<div class="dropdown-item color-206CF" href="#"
			     v-on:click="selectSorting('terbesar', jenisFilter)"
			     :class="{ 'selected-filter' : selectedSorting === 'terbesar' }"
			     v-if="jenisFilter === 'listPotongan' || jenisFilter === 'listKasbon'"
			>
				Terbesar
				<img src="../assets/icons/checked-blue.svg" alt="" class="m-l-12" v-if="selectedSorting === 'terbesar'">
			</div>
			<div class="dropdown-item color-206CF" href="#"
			     v-on:click="selectSorting('terkecil', jenisFilter)"
			     :class="{ 'selected-filter' : selectedSorting === 'terkecil' }"
			     v-if="jenisFilter === 'listPotongan' || jenisFilter === 'listKasbon'"
			>
				Terkecil
				<img src="../assets/icons/checked-blue.svg" alt="" class="m-l-12" v-if="selectedSorting === 'terkecil'">
			</div>
			
			<div id="filtertersembunyi" v-if="jenisFilter === 'outlet' || jenisFilter === 'outletNonaktif'" class="border-top">
				<div class="color-0000 dropdown-item">Outlet</div>
				<div class="color-206CF">
					<div class="dropdown-item color-206CF" href="#"
					     v-on:click="selectSorting('', 'outletNonaktif')"
					     v-if="jenisFilter === 'outlet'">
						Tampilkan Outlet Nonaktif
					</div>
					<div class="dropdown-item color-E9F0FF color-206CF" href="#"
					     v-on:click="selectSorting('', 'outlet')"
					     v-else-if="jenisFilter === 'outletNonaktif'">
						Tampilkan Outlet Nonaktif
						<span><img class="" src="../assets/icons/checkmark-outline.svg" alt=""></span>
					</div>
				</div>
			</div>
			
			<div id="filterterwsembunyi" v-if="jenisFilter === 'workshop' || jenisFilter === 'workshopNonaktif'" class="border-top">
				<div class="color-0000 dropdown-item">Workshop</div>
				<div class="color-206CF">
					<div class="dropdown-item color-206CF" href="#"
					     v-on:click="selectSorting('', 'workshopNonaktif')"
					     v-if="jenisFilter === 'workshop'">
						Tampilkan Workshop Nonaktif
					</div>
					<div class="dropdown-item color-E9F0FF color-206CF" href="#"
					     v-on:click="selectSorting('', 'workshop')"
					     v-if="jenisFilter === 'workshopNonaktif'">
						Tampilkan Workshop Nonaktif
						<span><img class="" src="../assets/icons/checkmark-outline.svg" alt=""></span>
					</div>
				</div>
			</div>
		
		</div>
	</div>
</template>

<script>
	export default {
		name: "FilterSorting",
		props: [
			"jenisFilter", "sortByColumn"
		],
		data() {
			return {
				defaultPagination: {
					limit: 20,
					offset: 0,
					length: 0,
					pageNumber: 0,
					sortBy: "created_at",
					orderBy: "DESC",
					key: ""
				},
				selectedSorting: "",
			}
		},
		methods: {
			selectSorting(key, type) {
				var textSorting;
				var sortBy;
				var orderBy;
				
				if (!this.sortByColumn) {
					this.sortByColumn = "nama"
				}

				this.selectedSorting = key
				switch (key) {
					case "asc":
						textSorting = "Abjad A - Z "
						sortBy = this.sortByColumn;
						orderBy = "ASC";
						break;
					case "desc":
						textSorting = "Abjad Z - A "
						sortBy = this.sortByColumn;
						orderBy = "DESC";
						break;
					case "terbaru":
						textSorting = "Terbaru "
						sortBy = "created_at";
						orderBy = "DESC";
						break;
					case "terlama":
						textSorting = "Terlama  "
						sortBy = "created_at";
						orderBy = "ASC";
						break;
					case "terbaruAbsensi":
						textSorting = "Terbaru "
						sortBy = "urutan";
						orderBy = "terbaru";
						break;
					case "terlamaAbsensi":
						textSorting = "Terlama  "
						sortBy = "urutan";
						orderBy = "terlama";
						break;
					case "terbesar":
						textSorting = "Terbesar "
						sortBy = "nominal";
						orderBy = "DESC";
						break;
					case "terkecil":
						textSorting = "Terkecil "
						sortBy = "nominal";
						orderBy = "ASC";
						break;
					default:
						textSorting = "Urutkan "
						sortBy = "created_at";
						orderBy = "DESC";
				}


				this.defaultPagination.sortBy = sortBy
				this.defaultPagination.orderBy = orderBy
				this.defaultPagination.pageNumber = 0
				this.defaultPagination.offset = 0
				this.$emit("filter", {data: this.defaultPagination, type: type, textSorting: textSorting})
			},
		},
	}
</script>

<style scoped>
	.selected-filter {
		background-color: #E9F0FF;
	}
</style>